import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class FootPrintApiManager_ds_find_tasksService {

  constructor(
    private utils: UtilsService,
    private settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { id?: number, orderId?: number, shipmentId?: number, statusId?: number[], operationCodeId?: number, chainHead?: number, actualTargetLicensePlateId?: number, actualSourceLicensePlateId?: number }): 
  Promise<{ result: { Id?: number, ActualSourceLicensePlateId?: number, ActualTargetLicensePlateId?: number, ActualTargetLocationId?: number, ChainHead?: number, OperationCodeId?: number, OrderId?: number, ShipmentId?: number, StatusId?: number }[] }> 
  {
    let url = `${environment.backendUrl}api/`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }
  public async getList(inParams: { id?: number, orderId?: number, shipmentId?: number, statusId?: number[], operationCodeId?: number, chainHead?: number, actualTargetLicensePlateId?: number, actualSourceLicensePlateId?: number, $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, ActualSourceLicensePlateId?: number, ActualTargetLicensePlateId?: number, ActualTargetLocationId?: number, ChainHead?: number, OperationCodeId?: number, OrderId?: number, ShipmentId?: number, StatusId?: number }[], totalCount: number }> 
  {
    let url = `${environment.backendUrl}api/`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { id?: number, orderId?: number, shipmentId?: number, statusId?: number[], operationCodeId?: number, chainHead?: number, actualTargetLicensePlateId?: number, actualSourceLicensePlateId?: number, $keys: number[] }): 
  Promise<{ result: { Id?: number, ActualSourceLicensePlateId?: number, ActualTargetLicensePlateId?: number, ActualTargetLocationId?: number, ChainHead?: number, OperationCodeId?: number, OrderId?: number, ShipmentId?: number, StatusId?: number }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }


    
    hasMissingRequiredInParams(inParams: { 
      id?: number, orderId?: number, shipmentId?: number, statusId?: number[], operationCodeId?: number, chainHead?: number, actualTargetLicensePlateId?: number, actualSourceLicensePlateId?: number    }) {
      return false;
    }
}
